import axios from 'axios'

export const getAllAddress = (params) => {
  let remoteUrl = 'addresses'

  return axios.get(remoteUrl, {params: params})
}

export const getAddress = (configs) => {
  let remoteUrl = 'addresses/' + configs.id

  return axios.get(remoteUrl, {params: configs.params})
}

export const addAddress = (data) => {
  let remoteUrl = 'addresses'
  return axios.post(remoteUrl, data)
}

export const editAddress = (id, data) => {
  let remoteUrl = 'addresses/' + id
  return axios.put(remoteUrl, data)
}

export const deleteAddress = (id) => {
  let remoteUrl = 'addresses/' + id
  return axios.delete(remoteUrl)
}

export const restoreAddress = (id) => {
  return axios.post('addresses/' + id + '/restore', {})
}



// WEBPACK FOOTER //
// ./src/api/address.js